<template>

  <div class="row">
    <div class="col-12">
      <div style="text-align: right;margin-bottom: 5px;">
      <span>
        Viendo documentos que ingresaron
      </span> <span v-if="rangeSelected.valor !== 'personalizado'">
        {{ rangeSelected.nombre }}
      </span> <span v-if="rangeSelected.valor === 'personalizado'">
        entre el
        <datetime
            v-model="rangeFrom"
            input-class="input-date"
            :phrases="{ok: 'Seleccionar',
           cancel: 'Cancelar'}"
            value-zone="local"
            format="yyyy-MM-dd"
            data-cy="start-time"
        />
        y el
        <datetime
            v-model="rangeUntil"
            input-class="input-date"
            :phrases="{ok: 'Seleccionar', cancel: 'Cancelar'}"
            value-zone="local"
            format="yyyy-MM-dd"
            data-cy="end-time"
        />
        <span>
          <vs-button
              radius
              class="ml-3 d-inline"
              color="primary"
              type="border"
              icon="search"
              size="small"
              @click="onServerChange"
          />
        </span>
      </span>
        <vs-dropdown
            vs-trigger-click
            style="margin-left: 15px"
        >
          <a
              class="a-icon"
              href="#"
          > Cambiar
            <vs-icon
                class=""
                icon="expand_more"
            ></vs-icon>
          </a>
          <vs-dropdown-menu>
            <vs-dropdown-item
                style="width:200px"
                v-for="range in ranges"
                :key="range.valor"
                v-on:click.native="selectRange(range)"
            >
              {{ range.nombre }}
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
    </div>
    <div class="col-lg-3 pl-1">
      <ListCompanyDivisions
          onlygroup
          label="Dirección asociada al expediente"
          name="divicionId"
          v-model="serverConfig.solicitanteDivisionId"
          :placeholder="isAguasAndinas ? 'Seleccione':'Division'"
          small
          @input="onServerChange"
      />
    </div>
    <div class="col-lg-3 pl-1">
      <ListCompanyUnits
          label="Unidad asociada al expediente"
          name="unidadId"
          v-model="serverConfig.solicitanteGrupoId"
          placeholder="Seleccione"
          :parent-value="serverConfig.solicitanteDivisionId"
          small
          @input="onServerChange"
      />
    </div>
    <div class="col-lg-3 pl-1" v-if="view !== 'my-files'">
      <ListUser
        label="Usuario responsable del expediente"
        name="usuarioId"
        small
        v-model="serverConfig.destinoResponsableIds"
        :division-filter="serverConfig.solicitanteDivisionId"
        :group-filter="serverConfig.solicitanteGrupoId"
        placeholder="Seleccione"
        @input="onServerChange"
      />
    </div>
  </div>
</template>
<script>

import { mapGetters } from 'vuex';

import ListCompanyDivisions from '@/febos/chile/lists/components/ListCompanyDivisions';
import ListCompanyUnits from '@/febos/chile/lists/components/ListCompanyUnits';
import ListUser from '@/febos/chile/lists/components/ListUser';
import { aliasToDate, DATE_RANGE_LAST_6_MONTH, DATE_RANGES } from '@/febos/chile/commons/dateCommons';
import { updateSearchParams } from '@/febos/global/utils/router';

export default {
  props: ['value', 'defaultDate'],
  data() {
    const range = this.defaultDate ? this.defaultDate : DATE_RANGE_LAST_6_MONTH;
    const { view } = this.$route.params;
    return {
      view,
      ranges: DATE_RANGES,
      rangeSelected: range,
      rangeFrom: '',
      rangeUntil: '',
      serverConfig: {
        solicitanteDivisionId: '',
        solicitanteGrupoId: '',
        solicitanteDocumentoId: ''
      }
    };
  },
  created() {
    this.selectRange(this.rangeSelected);
  },
  computed: {
    ...mapGetters('Empresas', ['company']),
    isAguasAndinas() {
      return this.company.iut === '61808000-5';
    },
  },
  methods: {
    onServerChange() {
      const filters = Object.entries(this.serverConfig)
        .filter(([, value]) => !!value)
        .map(([key, value]) => (`${key}:${value}`))
        .join('|');
      console.log('filters', filters, this.serverConfig);
      const rangeFrom = this.$moment(this.rangeFrom).format('YYYY-MM-DD');
      const rangeUntil = this.$moment(this.rangeUntil).format('YYYY-MM-DD');
      const defaultFilters = `fechaCreacion:${rangeFrom}--${rangeUntil}`;
      const newFilters = filters ? `${defaultFilters}|${filters}` : defaultFilters;
      updateSearchParams({ filters: newFilters });
      this.$emit('on-server-filters-change', newFilters);
    },
    selectRange(range) {
      const { rangeFrom, rangeUntil } = aliasToDate(range.valor);
      this.rangeFrom = rangeFrom;
      this.rangeUntil = rangeUntil;
      this.rangeSelected = range;
      this.onServerChange(this.currentFilters);
    }
  },
  components: {
    ListCompanyDivisions,
    ListCompanyUnits,
    ListUser
  }
};

</script>
